import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { customerHandler } from '../../../redux/handlers';
import BusinessSettingsTabContact from './BusinessSettingsTabContact';
import BusinessSettingsTabInfo from './BusinessSettingsTabInfo';
import BusinessSettingsTabSale from './BusinessSettingsTabSale';

const TABS = [
  {
    id: 1,
    icon: 'i-document',
    label: 'ข้อมูลธุรกิจ',
    component: BusinessSettingsTabInfo
  },
  {
    id: 2,
    icon: 'i-location',
    label: 'ข้อมูลติดต่อ',
    component: BusinessSettingsTabContact
  },
  {
    id: 3,
    icon: 'i-setting',
    label: 'ตั้งค่าการขาย',
    component: BusinessSettingsTabSale
  }
];

const TabNavigation = ({ activeTab, onTabChange, isCreateMode }) => (
  <nav>
    <div className="nav nav-tabs nav-tabs-st-2" role="tablist">
      {TABS.map(({ id, icon, label }) => {
        const isDisabled = isCreateMode && id !== 1;
        return (
          <button
            key={id}
            className={`nav-link ${activeTab === id ? 'active' : ''} ${
              isDisabled ? 'disabled opacity-50 cursor-not-allowed' : ''
            }`}
            type="button"
            onClick={() => !isDisabled && onTabChange(id)}
            disabled={isDisabled}
          >
            <span className={`${icon} me-2`}></span> {label}
          </button>
        );
      })}
    </div>
  </nav>
);

export function BusinessSettings({ onSuccess }) {
  const dispatch = useDispatch();
  const { businessID } = useParams();
  const [activeTab, setActiveTab] = useState(1);
  const selectedBusiness = useSelector(state => state.customer.businesses?.business);
  const isCreateMode = !selectedBusiness;

  const handleTabChange = selectedTab => {
    setActiveTab(selectedTab);
    if (businessID) {
      dispatch(customerHandler.getBusinessGroupById(businessID));
    }
  };

  const handleSuccess = async result => {
    if (onSuccess) {
      onSuccess();
    }
  };

  const CurrentTabComponent = TABS.find(tab => tab.id === activeTab)?.component;

  if (!CurrentTabComponent) return null;

  return (
    <div>
      <TabNavigation activeTab={activeTab} onTabChange={handleTabChange} isCreateMode={isCreateMode} />
      <CurrentTabComponent onSuccess={handleSuccess} />
    </div>
  );
}
